/**
 * Generates a random number between the specified range, inclusive.
 * @deprecated use {@link integer}
 */
export const numberWithin = (from, to) => {
    return Math.floor(Math.random() * (to - from + 1)) + from;
};
/**
 * Generates a random number between the specified range, inclusive.
 */
export const integer = numberWithin;
/**
 * Pick random element of an array
 */
export const element = (array) => {
    return array[numberWithin(0, array.length - 1)];
};
/**
 * Pick {@link count} random elements of an array
 */
export const elements = (array, count) => {
    const result = [];
    const indexes = [...array.map((_, i) => i)];
    for (let i = 0; i < count; i++) {
        const pickedIndex = element(indexes);
        if (pickedIndex === undefined) {
            return result;
        }
        const pickedElement = array.at(pickedIndex);
        result.push(pickedElement);
        indexes.splice(pickedIndex, 1);
    }
    return result;
};
//# sourceMappingURL=Random.js.map